import { Router } from '@angular/router';
import { AuthService } from './../core/services/auth.service';
import { Component, OnInit } from '@angular/core';
import { LoginProvider } from '../shared/models/loginProvider';
import { AppStateService } from '../core/services/app-state.service';
import { NotificationState } from '../shared/models/notificationState';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit {
  username: string = '';
  password: string = '';
  loginProvider!: LoginProvider;
  applicationOptions = [
    { applicationId: 'ProductSupport', description: 'Administrative application' },
    { applicationId: 'Sapphire', description: 'Clinical application' }
  ];
  selectedApplication: string | null = null;
  submitted = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    private appState: AppStateService
) {}
  public appName: string = 'BREASE PLATFORM PROTOTYPE UI';
  public appLogo: string = '';

  public hideClearButton: boolean = false;
  public hidePasswordIcon: boolean = false;
  public copyRightText: string = `This software is made available by Philips Electronics Nederland B.V. and/or its affiliates (“Philips”) for the purpose of providing a prototype user interface for demonstration purposes only.It is not intended for use in any other context, including but not limited to any clinical or diagnostic use.Confidentiality: This software is confidential and proprietary to Philips and may not be disclosed or distributed without Philips' prior written consent.`;

    ngOnInit() {
        this.appState.forcedLogout$.subscribe(message => {
            if (message) {
                const state = new NotificationState();
                state.message = message;
                state.closable = true;
            }
        });
        this.validate();
    }

    validate() {
        this.authService.isLoggedIn.subscribe(isLoggedIn => {
            if (isLoggedIn) {
                this.router.navigate(['/dashboard']);
            }
        });
    }

    onSubmit(event: Event) {
      this.submitted = true;
      event.preventDefault();
      if (!this.selectedApplication) {
        // Optionally show a validation error here
        return;
      }
      const target = event.target as HTMLFormElement;
      const formData = new FormData(target);
      const loginData = {
        username: formData.get('username') as string || '',
        password: formData.get('password') as string || '',
        applicationId: this.selectedApplication
      };

      this.authService.getLoginProvider(loginData).subscribe({
        next: (response: LoginProvider) => {
          console.log('Login Provider:', response);
          if (response.status === "SUCCESS") {
            this.validate();
            // this.redirect(response.redirectUrl + "&redirect_uri=https://ampm-dev-us.f93f-use1.bb5ef68.hsp.philips.com/prototype-ui/dashboard");
          } else {
            console.error('Login provider is not defined');
          }
        },
        error: (err) => {
          console.error('Error fetching login provider:', err.message);
          // Show an error message to the user
        }
      });
    }

    private redirect(url: string) {
        location.href = url;
    }
}
